import gql from 'graphql-tag';

export const USER_SETTINGS_FRAGMENT = gql`
  fragment userSettings on User {
    name
    email
    givenName
    familyName
    picture
    locale
    hasExtraGSuiteScopes
    jobTitle
    jobDepartment
    completedOnboardingSteps
    defaultStatus
    timeZone
    language
    displayFilter
    feedDisplay
    displayTimeline
    baseDisplay
    accessControl
    status
    domain {
      id
      orgName
      url
      orgName
      industry
      email
      address
      authorizedDomain
      slackWorkspace {
        name
        slackId
      }
      picture
    }
  }
`;
